module.exports = __webpack_public_path__ + "static/img/zhyw.1e3d51ca.png";